import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useUser } from "../../context/UserAuthContext";
import { track } from "../../lib/analytics";
import Seo from "../../components/Seo";
import { toast } from "sonner";

const inp = "w-full px-4 py-3 text-sm rounded-sm border border-brand-gold-light/50 bg-white outline-none focus:border-brand-gold";

export default function Login() {
  const { login } = useUser();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next") || "/hesabim";
  const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false); const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setErr("");
    const res = await login(email, password); setLoading(false);
    if (res.ok) { track("login", {}); toast.success("Hoş geldin."); nav(next); }
    else setErr(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-6 py-28">
      <Seo title="Giriş" />
      <div className="w-full max-w-md bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-10">
        <Link to="/" className="block text-center font-serif text-2xl font-semibold text-brand-green mb-4">BİLGECE<span className="text-brand-gold align-super text-sm">™</span></Link>
        <h1 className="font-serif text-3xl text-brand-green text-center">Giriş Yap</h1>
        <p className="text-brand-text/60 text-sm text-center mt-1 mb-6">Bilgece hesabına giriş yap</p>
        <form onSubmit={submit} data-testid="login-form" className="space-y-4">
          <input required type="email" placeholder="E-posta" value={email} onChange={(e) => setEmail(e.target.value)} className={inp} data-testid="login-email" />
          <input required type="password" placeholder="Şifre" value={password} onChange={(e) => setPassword(e.target.value)} className={inp} data-testid="login-password" />
          {err && <p className="text-red-700 text-sm" data-testid="login-error">{err}</p>}
          <button disabled={loading} data-testid="login-submit" className="w-full bg-brand-gold text-brand-offwhite hover:bg-brand-green transition-colors py-3 rounded-sm font-semibold disabled:opacity-60">{loading ? "Giriş yapılıyor..." : "Giriş Yap"}</button>
        </form>
        <div className="flex justify-between mt-5 text-sm">
          <Link to="/sifremi-unuttum" className="text-brand-text/60 hover:text-brand-green">Şifremi unuttum</Link>
          <Link to={`/kayit${next !== "/hesabim" ? `?next=${next}` : ""}`} className="text-brand-gold font-medium">Kayıt Ol</Link>
        </div>
      </div>
    </div>
  );
}
